export default __webpack_public_path__ + "3fbcff65c5e742372e341ac016b11b6b.jpg";